const mediaQueries = {
  phone: "@media only screen and (max-width: 500px)",
  phoneSm: "@media only screen and (max-width: 375px)",
  desktopSm: "@media only screen and (max-width: 1199px)",
  tablet: "@media only screen and (max-width: 992px)",
};

export default mediaQueries;



// WEBPACK FOOTER //
// ./src/styles/mediaQueries.js